import styled from "styled-components";

export const HomeContainer = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
`;

export const IntroductionContainer = styled.div``;

export const HomeIllustrationImage = styled.img``;
